import { render, staticRenderFns } from "./CompletedCandidates.vue?vue&type=template&id=142afdd6&scoped=true"
import script from "./CompletedCandidates.vue?vue&type=script&lang=js"
export * from "./CompletedCandidates.vue?vue&type=script&lang=js"
import style0 from "./CompletedCandidates.vue?vue&type=style&index=0&id=142afdd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142afdd6",
  null
  
)

export default component.exports